export enum OtherEmailActions {
  ADMIN_TEST = 'admin_test',
  USER_ACCOUNT_WELCOME = 'user_account_welcome',
  USER_INVITATION = 'user_invitation',
  USER_IDENTITY_VERIFIED = 'user_identity_verified',
  USER_IDENTITY_REJECTED = 'user_identity_rejected',
  USER_NEW_CONNECTION = 'user_new_connection',
}
